import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../Render/RendersStyle.css";
import Styles from "../Render/Render.module.css";
import { info, Scrollx_animate } from "../../../assets/icons";

import EC_Render from "../../../UiComponents/EC_Render";
import Navbar from "../Navbar/Navbar";
import Navbar_render from "../Render/Nav_render/Navbar_render";
import RenderSettings from "../Render/RenderSettings";
import RendersTable from "../Render/RendersTable";

import Render_PlanCubeCard from "../../UserPlan/Render_PlanCubeCard";
import AllPlansList from "../../UserPlan/AllPlansList";

import Dropdown_render from "../../../Components/Dropdown/Dropdown_render";
import Dropdown_renderFrame from "../../../Components/Dropdown/Drodpdrown_renderFrame";
import { Button, Checkbox } from "../../../Components";

import {
  commonFps,
  fpsNumAndDen,
  renderSettingsOptions,
  format,
} from "../Render/render.constants";
import html2canvas from "html2canvas";
import dataURItoBlob from "../../../services/dataToBlob";
import { setCurrentNotification } from "../../utils/global";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { increaseRenderCnt } from "../../../Redux/actions/authActions";
import { updatePreviewScale } from "../../../Redux/actions/applicationActions";
import { requestRenderX3Video } from "../../../Redux/actions/projectActions";
import {
  addNotifications,
  getCurrentPlan,
  getRendersPlan,
  getUserAllInformation,
  markRenderDone,
} from "../../../Redux/actions/commonActtion";

import PlanCubeCard from "../Render/PlanCubeCard";
import UpgradePlan from "../Render/UpgradePlan";
import ConfirmationModal from "../../../Components/ConfirmationModal/ConfirmationModal";

import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
} from "../../../Components/CustomToast/CustomToast";

const freeRenderFormats = Object.entries(format).map(([key, value]) => ({
  label: key,
  value: value,
}));
const freeFramRate = commonFps.map((fps) => ({ label: fps, value: 23.976 }));
const defaultResolution = "1280 x 720";
const mesg =
  "Rendering in Progress Your render is currently being processed. You will receive a notification via email when its complete. Thank you for your patience!";

const CardRender = ({
  renderOpen,
  setRenderOpen,
  isRenderExport,
  setIsRenderExport,
  // isCard,
}) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isUpgradeOpen, IsUpgradeOpen] = useState(false);
  const [isPlanShow, setIsPlanShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  let { isLoading, renders } = useSelector((state) => state?.project);
  const { _id, isCard } = useSelector((state) => state?.project);
  const { videoWidth, videoHeight } = useSelector(
    (state) => state?.project?.resolution,
  );
  const { credits } = useSelector((state) => state?.project);
  const { renderPlan, subscriptionStatus } = useSelector(
    (state) => state.commonReducer,
  );
  const commonReducer = useSelector((state) => state?.commonReducer);
  const { renderCnt } = useSelector((state) => state.userInfo);

  const { userData, renderDone, currentPlan } = useSelector(
    (state) => state?.commonReducer,
  );

  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(
    currentPlan.isExpired ? false : true,
  );

  useEffect(() => {
    setIsUserPaid(currentPlan.isExpired ? false : true);
  }, [currentPlan.isExpired]);

  // if user is paid, we are getting the settings from local storage, if user is not paid, we are removing the settings from local storage
  let renderSettingData = null;
  if (isUserPaid) {
    renderSettingData = JSON.parse(localStorage.getItem("renderSettings"));
  } else if (!isUserPaid) {
    if (renderSettingData) {
      localStorage.removeItem("renderSettings");
    }
  }
  // const renderSettingFormat = renderSettingData !== null ? renderSettingData.format !== "H264" ? renderSettingData.format.substring(6) : "H264" : "";
  const renderSettingFormat =
    renderSettingData !== null ? renderSettingData.format : "";

  // Getting default settings from local storage, if renderSettings is available otherwise we are taking default setting
  const [resolution, setResolution] = useState(
    renderSettingData !== null
      ? renderSettingData.resolution
      : defaultResolution,
  );
  const [formats, setFormats] = useState(
    renderSettingData !== null ? renderSettingFormat : "H264",
  );
  const [fps, setFps] = useState(
    renderSettingData !== null
      ? renderSettingData.fps
      : renderSettingsOptions[defaultResolution].fps[0],
  );
  const [sppf, setSpps] = useState(
    renderSettingData !== null ? renderSettingData.sppf : 5,
  );
  const [aspectRatio, setAspectRatio] = useState("1.78");
  const [isEmailSend, setIsEmailSend] = useState(true);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  // segregate the card specific options
  const [cardScreenOptions, setCardScreenOptions] = useState([]);

  useEffect(() => {
    if (!credits || credits.length === 0) return;

    const curatedOptions = credits.map((credit) => {
      const {
        screen_duration,
        transition_in,
        transition_in_duration,
        transition_out,
        transition_out_duration,
        delay,
      } = credit.options || {};

      return {
        screen_duration: Math.ceil((screen_duration || 0) * fps),
        transition_in: (transition_in || "").toLowerCase(),
        transition_in_duration:
          transition_in_duration && transition_in !== ""
            ? Math.ceil(transition_in_duration * fps)
            : 0,
        transition_out: (transition_out || "").toLowerCase(),
        transition_out_duration:
          transition_out_duration && transition_out !== ""
            ? Math.ceil(transition_out_duration * fps)
            : 0,
        delay: Math.ceil((delay || 0) * fps),
      };
    });

    setCardScreenOptions(curatedOptions);
  }, [credits, fps]);

  const user = JSON.parse(localStorage.getItem("user"));

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${
        createdAt?.getMonth() + 1
      }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [buyBackActive, setBuyBackActive] = useState();

  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;
    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
    const purchaseDate = currentPlan?.plan?.createdAt;
    if (purchaseDate) {
      const purchaseTime = new Date(purchaseDate);
      const buyBackTime = new Date(
        purchaseTime.getTime() + 3 * 24 * 60 * 60 * 1000,
      );
      const isBuyBackActive = buyBackTime >= new Date();

      setBuyBackActive(isBuyBackActive);
    }

    dispatch(getUserAllInformation());
  }, []);
  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);

  useEffect(() => {
    const roleName_tr = document.querySelectorAll(".roleName_tr");
    const Cardscrollable = document.querySelectorAll(".Cardscrollable");
    const emptyLogo = document.querySelectorAll(".border-for-empty-logo");
    const bulletClas = document.querySelectorAll(".bullet");
    const RespPreviewClass = document.querySelectorAll(".RespPreviewClass");
    const aspectRatioClassStyle = document.querySelectorAll(
      ".aspectRatioClassStyle",
    );
    const cardContentCenter = document.querySelectorAll(".cardContentCenter");
    const CardBlockCententHide = document.querySelectorAll(
      ".CardBlockCententHide",
    );
    const displayTitle = document.querySelectorAll(".displayTitle");

    function handleStatusChange() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "end";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-for-empty-logo")) {
            el.classList.replace(
              "border-for-empty-logo",
              "border-none-for-empty-logo",
            );
          }
        });
      }
      if (Cardscrollable) {
        Cardscrollable?.forEach((div) => {
          div.style.height = "100vh";
        });
      }
      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "inline-block";
          span.style.backgroundColor = "transparent";
          span.style.marginTop = "0.1em";
          // span.style.width = "1em";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = "1";
        });
      }
      if (aspectRatioClassStyle) {
        aspectRatioClassStyle?.forEach((div) => {
          div.style.border = "0px solid gray";
        });
      }
      if (cardContentCenter) {
        cardContentCenter?.forEach((div) => {
          div.style.width = "100vw";
        });
      }
      if (CardBlockCententHide) {
        CardBlockCententHide?.forEach((div) => {
          div.style.overflow = "hidden";
        });
      }
      if (displayTitle) {
        displayTitle?.forEach((div) => {
          div.style.display = "none";
        });
      }
    }

    handleStatusChange();
    return function cleanup() {
      if (roleName_tr) {
        roleName_tr?.forEach((tr) => {
          tr.style.display = "flex";
          tr.style.alignItems = "baseline";
        });
      }
      if (emptyLogo) {
        emptyLogo?.forEach((el) => {
          if (el.classList.contains("border-none-for-empty-logo")) {
            el.classList.replace(
              "border-none-for-empty-logo",
              "border-for-empty-logo",
            );
          }
        });
      }
      if (Cardscrollable) {
        Cardscrollable?.forEach((div) => {
          div.style.height = "100%";
        });
      }

      if (bulletClas) {
        bulletClas?.forEach((span) => {
          span.style.display = "flex";
          span.style.justifyContent = "center";
          span.style.alignItems = "center";
        });
      }
      if (RespPreviewClass) {
        RespPreviewClass?.forEach((div) => {
          div.style.zoom = ".8";
        });
      }
      if (aspectRatioClassStyle) {
        aspectRatioClassStyle?.forEach((div) => {
          div.style.border = "1px solid #373843";
        });
      }
      if (cardContentCenter) {
        cardContentCenter?.forEach((div) => {
          div.style.width = "100%";
        });
      }
      if (CardBlockCententHide) {
        CardBlockCententHide?.forEach((div) => {
          div.style.overflow = "inherit";
        });
      }
      if (displayTitle) {
        displayTitle?.forEach((div) => {
          div.style.display = "flex";
        });
      }
    };
  });

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };
  const handleResolutionChange = (val) => {
    setResolution(val);
    if (!renderSettingsOptions[val].fps.includes(fps)) {
      setFps(renderSettingsOptions[val].fps[0]);
    }
    setAspectRatio(renderSettingsOptions[val].aspectRatio);
  };

  const handleFormatChange = (val) => {
    setFormats(val);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };
  // console.log(credits);

  // function to get render time according to the png that is being formed from our side;
  const getHeight = () => {
    const totalDuration = credits
      .reduce((total, credit) => {
        const screen_duration = credit.options.screen_duration;
        const transition_in = credit.options.transition_in;
        const transition_out = credit.options.transition_out;
        const transition_in_duration =
          transition_in !== "" ? credit.options.transition_in_duration : 0;
        const transition_out_duration =
          transition_out !== "" ? credit.options.transition_out_duration : 0;
        const delay = credit.options.delay;
        return total + screen_duration + delay;
      }, 0)
      .toFixed(2);
    const min = Math.floor(totalDuration / 60);
    const sec = Math.floor(totalDuration % 60);
    setMin(min);
    setSec(sec);
  };

  // Few Block height iscaling problem
  const handleExport = async () => {
    setLoading(true);
    try {
      const blocks = document.querySelectorAll(".blockWrapper");
      const FontBlocks = document.querySelectorAll(".FontSIzeScale");

      // Store the original dimensions and font sizes before scaling
      const originalHeights = Array.from(blocks).map((el) => el.clientHeight);
      const originalWidths = Array.from(blocks).map((el) => el.clientWidth);
      const originalFontSize = Array.from(FontBlocks).map((el) =>
        parseFloat(window.getComputedStyle(el).fontSize),
      );
      blocks.forEach((el, index) => {
        el.style.width = videoWidth + "px";
      });

      // Calculate the scaling factor based on the selected resolution
      const previewBlockWidth = 800;
      const resolutionScale = videoWidth / previewBlockWidth;

      // Scale font size for the preview
      FontBlocks.forEach((el, index) => {
        const baseFontSize = originalFontSize[index]; // Use the original font size
        const fontScale = resolutionScale * baseFontSize + 1.6; // Multiply by 2 to increase the size significantly

        FontBlocks[index].style.fontSize = fontScale + "px";
      });

      const scrollPixelPerFrame = sppf;
      const { num: fpsNumerator, den: fpsDenominator } = fpsNumAndDen[fps];

      const focusedNode = document.querySelector(".CardfocusDiv");
      focusedNode?.classList?.remove("CardfocusDiv");

      const element = document.getElementById("preview");
      element.classList.remove("Cardscrollable");

      element.setAttribute(
        "style",
        `width: ${videoWidth}px;height:100%;background-color: transparent;`,
      );

      const elementsToUpdate = document.querySelectorAll(
        ".blockWrapper .watermark, .blockWrapper .watermark_displaynone",
      );

      elementsToUpdate.forEach((element) => {
        if (isUserPaid) {
          element.classList.replace("watermark", "watermark_displaynone");
        } else {
          element.classList.replace("watermark_displaynone", "watermark");
        }
      });

      await sleep(1000);
      const images = [];
      for (let idx = 0; idx < blocks.length; idx++) {
        const item = blocks[idx];
        const canvas = await html2canvas(item, {
          backgroundColor: null,
          scale: 1,
        });
        const blob = dataURItoBlob(canvas.toDataURL("image/png", 1.0));
        images.push({ blob, idx });
      }

      // Save render settings to localStorage
      localStorage.setItem(
        "renderSettings",
        JSON.stringify({
          resolution: resolution,
          format: formats,
          sppf: scrollPixelPerFrame,
          fps: fps,
        }),
      );

      const renderResult = await dispatch(
        requestRenderX3Video(images, cardScreenOptions, {
          videoHeight,
          videoWidth,
          scrollPixelPerFrame,
          fpsDenominator,
          fpsNumerator,
          format: formats === "H264" ? "outputH264" : formats,
          aspectRatio,
          isEmailSend,
        }),
      );

      setRenderOpen(false);
      setIsRenderExport(true);

      element.removeAttribute("style");
      focusedNode?.classList?.add("CardfocusDiv");
      element?.classList?.add("Cardscrollable");

      // // Restore original styles
      blocks.forEach((el, index) => {
        el.style.height = originalHeights[index] + "px";
        el.style.minHeight = originalHeights[index] + "px";
      });

      dispatch(updatePreviewScale(1));

      if (renderResult?.success) {
        toast(<CustomToast title="" content={mesg} />, customToatStyle);
        const newRender = renderResult.renders;
        const renderId = newRender[newRender.length - 1]._id;

        const notifyObj = {
          name: "render",
          details: newRender[newRender.length - 1],
          project_id: _id,
          render_id: renderId,
          message: `Rendering Completed ${
            newRender[newRender.length - 1].videoFilename
          }`,
          status: 1,
          user_id: user._id,
        };
        setCurrentNotification(notifyObj);
        await dispatch(
          addNotifications({
            project_id: _id,
            render_id: renderId,
            message: `Render in progress ${
              newRender[newRender.length - 1].videoFilename
            }`,
            status: 1,
            user_id: user._id,
          }),
        );
        dispatch(increaseRenderCnt());

        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        toast(
          <CustomToast title="" content={"Card Render Failed"} />,
          customToatStyle,
        );
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleExportSubmit = () => {
    if (!renderDone && buyBackActive) {
      dispatch(markRenderDone());
    }
    
    if (isUserPaid) {
      handleExport();
    }
    
    if (!isUserPaid) {
      navigate("/user-plans", {
        state: {
          isRender: true,
          isMoreInfo: false,
          isCard: isCard,
          projectId: projectId ?? null,
        },
      });
      return;
    }
  };

  renders = renders?.sort(
    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
  );

  const paideRenderSettingsOptions = Object.keys(renderSettingsOptions).map(
    (resolutionType) => {
      return { label: resolutionType, value: resolutionType };
    },
  );
  const paideRenderFormats = Object.entries(format).map(([key, value]) => ({
    label: key,
    value: value,
  }));
  const paidFramRate = renderSettingsOptions[resolution]?.fps?.map((_fps) => ({
    label: _fps,
    value: _fps,
  }));
  const expirationMessage =
    Object.keys(currentPlan).length === 0
      ? "With scrollx watermark"
      : remainingDays === 0
        ? "Plan Expired"
        : remainingDays === 1 || validityValue === 1
          ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
          : remainingDays > 1
            ? `Remaining ${remainingDays} days`
            : "";

  function addIntervalToPurchaseDate(
    planPurchaseDate,
    interval_count,
    interval_type,
  ) {
    const purchaseDate = planPurchaseDate;

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate =
    currentPlanDetails !== null
      ? addIntervalToPurchaseDate(
          createdAt,
          currentPlanDetails?.interval_count,
          currentPlanDetails?.interval,
        )
      : new Date();

  const expiryString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Expiration Date ${expirationDate.getDate()}/${
          expirationDate.getMonth() + 1
        }/${expirationDate.getFullYear()}`
      : "";
  const renewalString =
    currentPlanDetails !== null && expirationDate !== null
      ? `Renewal Date ${expirationDate.getDate()}/${
          expirationDate.getMonth() + 1
        }/${expirationDate.getFullYear()}`
      : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  useEffect(() => {
    getHeight();
  }, [sppf, fps, resolution]);

  return (
    <>
      {/* <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        message="By clicking 'Render', you agree that the 3-day money-back guarantee will be void. Are you sure you want to continue?"
      /> */}
      <EC_Render isOpen={renderOpen} closeModal={() => setRenderOpen(false)}>
        {loading ? (
          <div className={Styles.modalOverlayLoader}>
            <img
              src={Scrollx_animate}
              className="absolute opacity-80"
              width="120px"
              height="120px"
            />
            <p className="mt-[8rem] text-[0.9rem] text-white">
              Requesting Video ...
            </p>
          </div>
        ) : null}

        <div className="w-full h-full">
          <div className="renderHead">
            <Navbar_render closeModal={() => setRenderOpen(false)} />
            {/* <Navbar renderOpen={renderOpen} setRenderOpen={setRenderOpen} /> */}
          </div>

          <div className={Styles.PageContainer}>
            <div className={Styles.renderUpperContainer}>
              <div className={Styles.renderContainer}>
                <div className={Styles.mainContainer}>
                  <div className={Styles.renderSettings}>
                    <div className="w-[90%]  flex justify-between pt-[5px]  border-b-[1px] pb-[10px] border-[#373843]">
                      <div>
                        <h1 className="manrope-800 capitalize lg:text-[1.5rem] text-[0.9rem] text-white">
                          Select Render Settings
                        </h1>
                      </div>
                      <div className="">
                        <img
                          className="w-[18px] cursor-pointer"
                          src={info}
                          alt=""
                          onClick={() =>
                            window.open(`/help/6708ed7949a4f8d9d07c0466`)
                          }
                        />
                      </div>
                    </div>
                    <div className={Styles.mainSettings}>
                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Resolution</label>
                        <input
                          type="text"
                          className="w-full p-1 text-[13px]"
                          value={`${videoWidth} X ${videoHeight}`}
                          readOnly
                          style={{
                            backgroundColor: "var(--ShadeGray800)",
                            textAlign: "center",
                            width: "115px",
                            borderRadius: ".5rem",
                            padding: "2px 8px",
                            fontWeight: "400",
                            fontFamily: "Manrope, sans-serif",
                            fontsize: "13px",
                            marginLeft: "0px",
                            color: "var(--white)",
                            height: "32px",
                            border: "1px solid gray",
                          }}
                        />
                      </div>
                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Aspect Ratio</label>
                        <input
                          type="text"
                          className="w-full text-[13px] p-1 "
                          value={aspectRatio}
                          readOnly
                          style={{
                            backgroundColor: "var(--ShadeGray800)",
                            textAlign: "center",
                            width: "120px",
                            borderRadius: ".5rem",
                            padding: "2px 8px",
                            fontFamily: "Manrope, sans-serif",
                            fontsize: "13px",
                            color: "var(--white)",
                            fontWeight: "400",
                            height: "32px",
                            border: "1px solid gray",
                          }}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Format</label>
                        <Dropdown_render
                          isUserPaid={isUserPaid}
                          options={
                            isUserPaid ? paideRenderFormats : freeRenderFormats
                          }
                          value={formats}
                          onChange={(value) => {
                            isUserPaid && handleFormatChange(value);
                          }}
                          IsUpgradeOpen={IsUpgradeOpen}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthSet}>Frame Rate</label>
                        <Dropdown_renderFrame
                          isUserPaid={isUserPaid}
                          options={isUserPaid ? paidFramRate : freeFramRate}
                          value={fps}
                          onChange={setFps}
                          IsUpgradeOpen={IsUpgradeOpen}
                        />
                      </div>

                      <div className={Styles.settingsOption}>
                        <label className={Styles.widthframe}>
                          Running Time
                        </label>

                        <div
                          className={Styles.renderTime}
                          style={{
                            border: "1px solid gray",
                            marginBottom: "2px",
                          }}
                        >
                          <div>
                            <span className="mr-1">
                              {String(min).padStart(2, "0")}
                              <span>{" :"}</span>
                            </span>
                            <span>{String(sec).padStart(2, "0")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex w-[90%] py-1 items-center justify-between">
                      <div
                        className={Styles.settingsOptionBtn}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className={Styles.ExportBtn}
                          onClick={handleExportSubmit}
                          disabled={isLoading && loading}
                          // onClick={()=>( window.open("/paymentsuccess", '_blank'))}
                        >
                          <span className="manrope-800 ">Render</span>
                        </div>
                      </div>
                      <div className={Styles.settingsOptionMsgBtn}>
                        <Checkbox
                          isEmailSend={isEmailSend}
                          setIsEmailSend={setIsEmailSend}
                        />
                        <label className={Styles.checkboxLabel}>
                          Email me when render is complete
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <RenderSettings isCard={isCard} IsUpgradeOpen={IsUpgradeOpen} isUserPaid={isUserPaid} paideRenderSettingsOptions={paideRenderSettingsOptions} resolution={resolution} handleResolutionChange={handleResolutionChange} paideRenderFormats={paideRenderFormats} freeRenderFormats={freeRenderFormats} formats={formats}
                handleFormatChange={handleFormatChange} paidFramRate={paidFramRate} freeFramRate={freeFramRate} fps={fps} setFps={setFps} sppf={sppf} setSpps={setSpps} min={min} sec={sec} handleExportSubmit={handleExportSubmit} isLoading={isLoading}
                loading={loading} isPlanActive={isPlanActive} renderCnt={renderCnt} isEmailSend={isEmailSend} setIsEmailSend={setIsEmailSend}  videoWidth={videoWidth} videoHeight={videoHeight} aspectRatio={aspectRatio}
                /> */}
              </div>

              <div className={Styles.renderSubcriptionContainer}>
                <Render_PlanCubeCard
                  isPlanShow={isPlanShow}
                  setIsPlanShow={setIsPlanShow}
                />

                {/* <PlanCubeCard iscurrentPlanActivate={iscurrentPlanActivate}
                    lable={
                      isPlanActive
                        ? `${
                            currentPlanDetails?.interval_count === 7
                              ? "Weekly"
                              : currentPlanDetails?.interval_count === 30
                              ? "Monthly"
                              : ""
                          } ${currentPlanDetails?.type} Plan`
                        : "Basic Plan"
                    }
                    currentPlan={
                      currentPlanDetails?._id
                        ? currentPlanDetails?.type
                        : "Free"
                    }
                    rendersLimit={
                      isPlanActive
                        ? currentPlanDetails?.text1
                        : "Limited scroll and card renders with watermark"
                    }
                    projectLimits={
                      isPlanActive ? currentPlanDetails?.text2 : ""
                    }
                    support={
                      currentPlanDetails?._id
                        ? "Support " + currentPlanDetails?.text4
                        : "Only support 720p"
                    }
                    validity={
                      currentPlanDetails?._id
                        ? "validity " + currentPlanDetails?.validity
                        : ""
                    }
                    planRenueDate={expirationMessage}
                    expiryString={expiryString}
                    renewalString={renewalString}
                    planPurchaseDate={planPurchaseDate}
                    buttonLable={"Upgrade"}
                    onClick={() => IsUpgradeOpen(true)}
                    paymentType={currentPlan?.plan?.payment_type}
                    order_id={currentPlan?.plan?.order_id}
                    subscription_status={currentPlan?.plan?.subscription_status}
                  /> */}
              </div>
            </div>

            <div className={Styles.renderDownContainer}>
              <RendersTable isCard={isCard} />
            </div>
          </div>

          {/* {isUpgradeOpen && (
            <UpgradePlan
              isUpgradeOpen={isUpgradeOpen}
              IsUpgradeOpen={IsUpgradeOpen}
              renderPlan={renderPlan}
              currentPlanDetails={currentPlanDetails}
              remainingDays={remainingDays}
              setRenderOpen={setRenderOpen}
              planPurchaseDate={planPurchaseDate}
              expirationMessage={expirationMessage}
              getTime={getTime}
              setIsSuccessOpen={setIsSuccessOpen}
              paymentType={currentPlan?.plan?.payment_type}
              order_id={currentPlan?.plan?.order_id}
              subscription_status={currentPlan?.plan?.subscription_status}
              buttonText={'Current'}
            />
          )} */}

          {isPlanShow && (
            <AllPlansList
              isPlanShow={isPlanShow}
              setIsPlanShow={setIsPlanShow}
            />
          )}
        </div>
      </EC_Render>
    </>
  );
};

export default CardRender;
